import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Subject, takeUntil } from 'rxjs';

import { AuthService } from '../auth.service';

@Component({
  selector: 'app-candidate-login',
  templateUrl: './candidate-login.component.html',
  styleUrls: ['./candidate-login.component.scss'],
})
export class CandidateLoginComponent implements OnInit, OnDestroy {
  public loginFormGroup: FormGroup;
  public isLoading = false;
  public errorMessage: string | null = null;
  public hidePassword = true;

  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private socialAuthService: SocialAuthService
  ) {
    this.loginFormGroup = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/candidate']);
    }

    this.socialAuthService.authState
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: SocialUser) => {
        if (user) {
          this.handleSocialLogin(user);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public signIn(): void {
    if (this.loginFormGroup.valid) {
      this.isLoading = true;
      this.errorMessage = null;
      this.authService.login({
        email: this.loginFormGroup.value.email,
        password: this.loginFormGroup.value.password,
      });
    }
  }

  private async handleSocialLogin(user: SocialUser): Promise<void> {
    try {
      this.isLoading = true;
      this.errorMessage = null;
      await this.authService.loginSocial(user);
      this.router.navigate(['/candidate']);
    } catch (error) {
      this.errorMessage = 'Social login failed. Please try again.';
      this.isLoading = false;
    }
  }

  public navigateToRegister(): void {
    this.router.navigate(['/candidate-register']);
  }
}
